import en from './locales/en.json';
import ja from './locales/ja.json';

export default defineI18nConfig(() => ({
  legacy: false,
  locale: 'en',
  // Use English for keys omitted from ja (e.g. HMS field labels that stay in English).
  fallbackLocale: 'en',
  messages: {
    en: en,
    ja: ja,
  },
}));
